
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDeleteFilled as ObiDeleteFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-delete-filled.js';
 
 
 

 
 export const ObiDeleteFilled = createComponent({
   react: React,
   tagName: 'obi-delete-filled',
   elementClass: ObiDeleteFilledElement,
   events: {
     
   }
  });
 
 